/** Только цифры кода: «123 456» → «123456». */
export const digitsOnly = (value: string) => value.replace(/\D/g, '').slice(0, 6)
